"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
const Section = props => {
  const {
    withAboveBorder,
    numberVal = "",
    children,
    title,
    sectionStatusComponent,
    formBodyClassName = ""
  } = props;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `section__form section__form${numberVal} ${withAboveBorder ? "section__form--border-top" : ""}`
  }, title && /*#__PURE__*/_react.default.createElement("h1", null, numberVal && /*#__PURE__*/_react.default.createElement("span", {
    className: "section__number"
  }, numberVal), title, sectionStatusComponent && sectionStatusComponent), /*#__PURE__*/_react.default.createElement("div", {
    className: `section__form--body ${formBodyClassName}`
  }, children));
};
exports.Section = Section;
Section.propTypes = {
  withAboveBorder: _propTypes.default.bool,
  numberVal: _propTypes.default.string
};